import { render, staticRenderFns } from "./ProfilePaymentDetails.vue?vue&type=template&id=1fd5095c"
import script from "./ProfilePaymentDetails.vue?vue&type=script&lang=js"
export * from "./ProfilePaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports